import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取物流公司列表
   */
  getShippingCompanyList() {
    return Ajax.get(`/api/MallConfigManagement/ShippingCompany`)
  },
  /**
   * 获取物流公司信息
   * @param id 
   */
  getShippingCompany(id: string) {
    return Ajax.get(`/api/MallConfigManagement/ShippingCompany/${id}`)
  },
  /**
   * 更新物流公司
   */
  updateShippingCompany(value: object, id?: string) {
    let url = '/api/MallConfigManagement/ShippingCompany'
    if (id) {
      url += '/' + id
    }
    let ajaxType = id ? 'put' : 'post'
    return Ajax[ajaxType](url, value)
  },

  /**
   * 获取运费模板列表
   */
  getShippingTemplateList(id: string, pageSize: number, currentPage: number) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    }
    return Ajax.get(`/api/MallConfigManagement/ShippingCompany/ShippingTemplateList/${id}`, {params})
  },

  /**
   * 获取运费模板
   * @param id 
   */
  getShippingTemplate(id: string, shippingTemplateId: string) {
    return Ajax.get(`/api/MallConfigManagement/ShippingCompany/ShippingTemplate/${id}`, {
      params: {
        shippingTemplateId: shippingTemplateId
      }
    })
  },

  /**
   * 创建/更新运费模板
   */
  updateShippingTemplate(id: string, value: object) {
    return Ajax.put(`/api/MallConfigManagement/ShippingCompany/ShippingTemplate/${id}`, value)
  },

  /**
   * 删除运费模板
   */
  deleteShippingTemplate(id: string, shippingTemplateId: string) {
    return Ajax.delete(`/api/MallConfigManagement/ShippingCompany/ShippingTemplate/${id}`, {
      params: {
        shippingTemplateId: shippingTemplateId
      }
    })
  }
}